import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  /**
   * If `true`, a "loading" overlay will display instead of the modal body
   * content.
   */
  loading?: boolean;
  /**
   * If `true`, a "processing" overlay will display over the modal body content.
   */
  processing?: boolean;
  /**
   * If `true`, a green checkmark overlay will display over the modal body content.
   */
  success?: boolean;
  /**
   * If `true`, a red X overlay will display over the modal body content.
   */
  errored?: boolean;
  /**
   * If `true`, the modal body will not include its standard padding.
   */
  noPadding?: boolean;
  /**
   * If `true`, the modal body will be prevented from being scrollable.
   */
  noScroll?: boolean;
}


import { defineComponent } from 'vue';

import Overlay from '@components/Overlay.vue';
import Spinner from '@components/Spinner.vue';
import AnimatedCheckmark from '@client/components/AnimatedCheckmark.vue';
import AnimatedSuccess from '@client/components/AnimatedSuccess.vue';
import AnimatedError from '@client/components/AnimatedError.vue';
declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    ModalBody: ComponentWithProps<Props>;
  }
}

const __default__ = defineComponent({ name: 'ModalBody' });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    loading: { type: Boolean, default: false },
    processing: { type: Boolean, default: false },
    success: { type: Boolean, default: false },
    errored: { type: Boolean, default: false },
    noPadding: { type: Boolean, default: false },
    noScroll: { type: Boolean }
  },
  setup(__props: any) {

/** `ModalBody` component properties. */


return { __sfc: true,Overlay, Spinner, AnimatedSuccess, AnimatedError }
}

})